const i = {
  name: "AccessibilityFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 8C12.83 8 13.5 7.31457 13.5 6.49007C13.5 5.66556 12.83 5 12 5C11.17 5 10.5 5.66556 10.5 6.49007V6.5298C10.5 7.3543 11.17 8 12 8ZM13.5316 10.8789C14.838 10.7402 16.1299 10.4235 17.3704 9.92886L16.6296 8.07111C13.6574 9.25627 10.3426 9.25627 7.37039 8.07111L6.62961 9.92886C7.87011 10.4235 9.16204 10.7402 10.4684 10.8789C10.3997 11.7782 10.2196 12.6659 9.93209 13.5214L8.55109 17.6745L10.4489 18.3055L11.8279 14.1586L11.8284 14.157C11.8898 13.9744 11.947 13.7906 12 13.6057C12.053 13.7906 12.1102 13.9744 12.1716 14.157L12.1721 14.1586L13.5511 18.3055L15.4489 17.6745L14.0689 13.5245L14.0679 13.5214C13.7804 12.6659 13.6003 11.7782 13.5316 10.8789Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as AccessibilityFilled
};
